import { useEffect, useState } from 'react'
import { useRouter } from 'next/router'

/** True while a page or its data is loading after a link, filter or refresh. */
export const useRouteLoading = (delay = 120): boolean => {
    const router = useRouter()
    const [loading, setLoading] = useState(false)

    useEffect(() => {
        let timer: ReturnType<typeof setTimeout> | undefined

        const start = (_url: string, options?: { shallow?: boolean }) => {
            if (options?.shallow) return

            clearTimeout(timer)
            timer = setTimeout(() => setLoading(true), delay)
        }

        const done = () => {
            clearTimeout(timer)
            setLoading(false)
        }

        router.events.on('routeChangeStart', start)
        router.events.on('routeChangeComplete', done)
        router.events.on('routeChangeError', done)

        return () => {
            clearTimeout(timer)
            router.events.off('routeChangeStart', start)
            router.events.off('routeChangeComplete', done)
            router.events.off('routeChangeError', done)
        }
    }, [router.events, delay])

    return loading
}
